import React, { useCallback, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { DialogProps } from '@mui/material';
import { Modal } from '../../../../components/other/Modals';
import { useSearchUsers } from '../../users/users/hooks/useSearchUsers';
import VendorsList from '../components/VendorsList';

export enum ViewMode {
  VIEW = 'view',
  EDIT = 'edit',
}

export function DriverModal({
  showDriverModal,
  closeDriverModal,
  setFieldValue,
  values,
}: {
  showDriverModal: boolean;
  closeDriverModal: () => void;
  setFieldValue: any;
  values: any;
}) {
  const {
    fetchUsers: fetchSearchUsers,
    loading: searchLoading,
    loadingPhone,
    page: searchPage,
    perPage: searchPerPage,
    total: searchTotal,
    users: searchUsers,
  } = useSearchUsers();

  const {
    fetchUsers,
    loading: loadingUsers,
    page: pageUsers,
    perPage: perPageUsers,
    total: totalUsers,
    users,
  } = useSearchUsers();

  const searchGetUsersStaff = useCallback(
    (data: { fio?: string; phone?: string; id?: number }) => {
      fetchSearchUsers({
        page: searchPage,
        per_page: searchPerPage,
        fio: data.fio,
        phone: data.phone,
        id: data.id,
        roles: 'ROLE_VENDOR',
      });
    },
    [searchPage, searchPerPage]
  );

  useEffect(() => {
    if (showDriverModal) {
      fetchUsers({ page: 1, per_page: 20, roles: 'ROLE_VENDOR' });
    }
  }, [showDriverModal]);

  const intl = useIntl();

  return (
    <>
      <Modal
        DialogProps={{ maxWidth: 'md' } as DialogProps}
        open={showDriverModal}
        onClose={closeDriverModal}
        title={intl.formatMessage({ id: 'DRIVERS.ALL' })}
        loading={loadingUsers}
        content={
          <VendorsList
            searchUsers={searchUsers}
            searchLoading={searchLoading}
            searchGetUsersStaff={searchGetUsersStaff}
            users={users}
            setFieldValue={setFieldValue}
            values={values}
            pageUsers={pageUsers}
            perPageUsers={perPageUsers}
            totalUsers={totalUsers}
            fetchUsers={fetchUsers}
            closeDriverModal={closeDriverModal}
          />
        }
        actions={[
          {
            title: intl.formatMessage({ id: 'COMMON.BUTTON.CLOSE' }),
            onClick: () => closeDriverModal(),
          },
        ]}
      />
    </>
  );
}
